export default __webpack_public_path__ + "static/media/Customers.fa281d97.svg";